import { IconComponent } from './types';

const CheckIcon: IconComponent = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="8"
      fill="none"
      viewBox="0 0 9 7"
    >
      <path
        d="M3.22456 4.94482L1.56509 3.39001L1 3.91573L3.22456 6L8 1.52573L7.43889 1L3.22456 4.94482Z"
        fill="#212121"
        stroke="#221121"
      />
    </svg>
  );
};

export default CheckIcon;
